import { render, staticRenderFns } from "./BlueActionButton.vue?vue&type=template&id=6629d998&scoped=true&"
import script from "./BlueActionButton.vue?vue&type=script&lang=js&"
export * from "./BlueActionButton.vue?vue&type=script&lang=js&"
import style0 from "./BlueActionButton.vue?vue&type=style&index=0&id=6629d998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629d998",
  null
  
)

export default component.exports